/**
 * Resolves a hotel from the subsidiary list by GUID (subsidiaryId) or displayId.
 * Deep links may use either: /s/{guid}/... or /s/{displayId}/...
 *
 * @param {Array<{ subsidiaryId?: string, displayId?: number|string }>} subsidiaryList
 * @param {string|number} idFromUrl
 * @returns {{ subsidiaryId: string, displayId?: number|string }|null}
 */
export function resolveSubsidiaryFromList(subsidiaryList, idFromUrl) {
  if (!Array.isArray(subsidiaryList) || idFromUrl == null || idFromUrl === '') {
    return null
  }

  const id = String(idFromUrl).trim()
  if (!id) {
    return null
  }

  const byGuid = subsidiaryList.find(s => String(s.subsidiaryId) === id)
  if (byGuid) {
    return byGuid
  }

  const byDisplayId = subsidiaryList.find(s => String(s.displayId) === id)
  if (byDisplayId) {
    return byDisplayId
  }

  return null
}
